export default "__VITE_ASSET__BN9RuMn9__"